import { descriptors } from './descriptors/index.js';
/** CRM base types the kit does not describe but whose records name an organisation. */
export const BASE_ORG_FIELDS = { contact: ['account_id'] };
export function orgFieldsFrom(ds) {
    const out = { ...BASE_ORG_FIELDS };
    for (const d of ds) {
        const fields = (d.relations ?? []).filter((r) => r.kind === 'belongsTo' && r.target === 'account').map((r) => r.name);
        if (fields.length)
            out[d.slug] = fields;
    }
    return out;
}
export function orgViaFrom(ds, fields) {
    const out = {};
    for (const d of ds) {
        if (fields[d.slug])
            continue;
        const byParent = new Map();
        for (const r of d.relations ?? []) {
            if (r.kind !== 'belongsTo' || r.target === d.slug || !fields[r.target])
                continue;
            byParent.set(r.target, [...(byParent.get(r.target) ?? []), r.name]);
        }
        // the business parent: a kit module before people, then the one linked by the most fields
        // (a measure names its threat twice and its audit once), then declaration order
        const parent = [...byParent.keys()].sort((a, b) => Number(!!BASE_ORG_FIELDS[a]) - Number(!!BASE_ORG_FIELDS[b]) || byParent.get(b).length - byParent.get(a).length)[0];
        if (parent)
            out[d.slug] = { fields: byParent.get(parent), parent, parentFields: fields[parent] };
    }
    return out;
}
export const orgFields = orgFieldsFrom(descriptors);
export const orgVia = orgViaFrom(descriptors, orgFields);
